export default __webpack_public_path__ + "static/media/write.7728007a.png";